﻿const QueryUtils = {
    transformObjectToQueryParams(object) {
        let query = new URLSearchParams();

        Object.keys(object).forEach(function (key) {
            query.set(key, object[key]);
        });

        return `?${query}`;
    }
};

export default QueryUtils;